module.exports = __webpack_public_path__ + "assets/img/chairs.845b9e41.png";